export default {
  namespaced: true,
  state: {
    loan: null,
    loansRepayment: null,
    offer: null,
    leftAmount: 0,
    leftMarketingAmount: 0,
    agreementData: {
      contract: null,
      term: null,
      offer: null,
      is_agreed: false,
      signature: null,
      image: null
    }
  },
  getters: {
    getOffer(state) {
      return state.offer
    },
    getLoanData(state) {
      return state.loan
    },
    getLoansRepayment(state) {
      return state.loansRepayment
    },
    getLeftAmount(state) {
      return state.leftAmount
    },
    getLeftMarketingAmount(state) {
      return state.leftMarketingAmount
    },
    getMarketingCount(state) {
      if (!state.loansRepayment) { return 0 }
      return state.loansRepayment.filter((loan) => loan.status === 'executed' && loan.type === 'marketing').length
    },
    getTotalLoanCount(state) {
      if (!state.loansRepayment) { return 0 }
      return state.loansRepayment.filter((loan) => loan.status === 'executed' && loan.type === 'normal').length
    },
    getAgreementData(state) {
      return state.agreementData
    }
  },
  mutations: {
    setOffer(state, offer) {
      state.offer = offer
    },
    setLoanData(state, loan) {
      state.loan = loan
    },
    setLoansRepayment(state, loansRepayment) {
      state.loansRepayment = loansRepayment
    },
    setLeftAmount(state, leftAmount) {
      state.leftAmount = leftAmount
    },
    setLeftMarketingAmount(state, leftMarketingAmount) {
      state.leftMarketingAmount = leftMarketingAmount
    },
    setAgreementData(state, agreementData) {
      state.agreementData.contract = agreementData.contract
      state.agreementData.term = agreementData.term
      state.agreementData.offer = agreementData.offer
      state.agreementData.is_agreed = agreementData.is_agreed
      state.agreementData.signature = agreementData.signature
      state.agreementData.image = agreementData.image
    }
  },
  actions: {
    setOffer({ commit }, offer) {
      commit('setOffer', offer)
    },
    setLoanData({ commit }, loan) {
      commit('setLoanData', loan)
    },
    setLoansRepayment({ commit }, loansRepayment) {
      commit('setLoansRepayment', loansRepayment)
    },
    setLeftAmount({ commit }, leftAmount) {
      commit('setLeftAmount', leftAmount)
    },
    setLeftMarketingAmount({ commit }, leftMarketingAmount) {
      commit('setLeftMarketingAmount', leftMarketingAmount)
    },
    setAgreementData({ commit }, agreementData) {
      commit('setAgreementData', agreementData)
    }
  }
}
